/**
 * This file gives a single import point to gather an
 * array of all the child routes for mag templates
 */

import Root from './Root';
import MagTemplateView from './MagTemplateView';

export default [
	Root,
	MagTemplateView
];
